<template>
  <!-- <h1>{{ this.$route.params.reset_token }}</h1> -->
  <div>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title class="purple--text justify-center title">Password reset</v-card-title>
      <v-form>
        <v-card-text>
            <p class="purple--text subheading">{{email}}</p>
          <v-text-field
            box
            color="purple"
            ref="password"
            name="password"
            label="Password"
            data-vv-name="password"
            data-vv-delay="300"
            min="8"
            v-validate="'required|min:8'"
            v-model="password"
            :error-messages="errors.collect('password')"
            :type="isPasswordVisible ? 'text' : 'password'"
            placeholder="Enter your password"
          >
            <template slot="append">
              <div @click="changeVal('isPasswordVisible')">
                <span v-if="!isPasswordVisible">Show</span>
                <span v-else>Hide</span>
              </div>
            </template>
          </v-text-field>
          <v-text-field
            box
            color="purple"
            label="CONFIRM PASSWORD"
            data-vv-name="password_confirmation"
            data-vv-delay="300"
            target="password"
            v-validate="'required|confirmed:password'"
            v-model="password_confirmation"
            :error-messages="errors.collect('password_confirmation')"
            :type="isPasswordVisible2 ? 'text' : 'password'"
            placeholder="Enter confirm password"
          >
            <template slot="append">
              <div @click="changeVal('isPasswordVisible2')">
                <span v-if="!isPasswordVisible2">Show</span>
                <span v-else>Hide</span>
              </div>
            </template>
          </v-text-field>
          <v-btn dark outline color="purple" class="submit" @click="submit">submit</v-btn>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
  <v-dialog v-model="errorDialog" max-width="350">
      <v-card>
        <v-card-title class="text-xs-center">{{errorMsg}}</v-card-title>
        <v-card-actions v-if="successRegister">
          <v-btn dark color="purple" @click="successRegistered">{{errorBtn}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Reset",
  data: () => ({
    dialog: true,
    token: "",
    password: "",
    password_confirmation: "",
    isPasswordVisible: false,
    isPasswordVisible2: false,
    email: "",
    successRegister: false,
    errorDialog: false,
    errorMsg: "IDK why do u see this window",
    errorBtn: "Ok",
    dictionary: {
      custom: {
        password: {
          required: () => "Password can not be empty",
          min: "The password field may not be lesser than 8 characters"
        },
        password_confirmation: {
          required: () => "Password confirmation can not be empty",
          confirmed: "The password confirmation does not match"
        }
      }
    }
  }),
  created() {
    this.token = this.$route.params.reset_token;
    console.log(this.token);
    axios.get(this.$hostname + "/reset/" + this.token).then(response => {
      this.email = response.data.data.email;
      console.log(this.email);
    });
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios
            .post(this.$hostname + "/reset/" + this.token, {
              password: this.password
            })
            .then(response => {
              console.log(response);
              if(response.status === 200){
                this.successRegister = true
                this.errorDialog = true
                this.errorBtn = "Back to Log in"
                this.errorMsg = `Your password was successfully changed!`
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    changeVal(value) {
      this[value] = !this[value];
    },
    successRegistered (){
      this.$router.push('/')
    }
  }
};
</script>
<style scoped lang="scss">
.password {
  max-width: 500px;
  margin: 0 auto;
}
.submit {
  display: block;
  margin: 0 auto;
}
</style>